<app-content>
  @if (appId) {
    <app-breadcrumbs>
      <li>
        <a routerLink='/wnioski-robocze' aria-label='Wnioski robocze'>
          Wnioski robocze
        </a>
      </li>
      <li>
        {{ serviceType()?.name || 'Ładowanie danych...' }}
      </li>
    </app-breadcrumbs>
  } @else {
    <app-breadcrumbs>
      <li>
        <a routerLink='/e-uslugi' aria-label='E-usługi'>E-usługi</a>
      </li>
      <li>
        {{ serviceType()?.name || 'Ładowanie danych...' }}
      </li>
    </app-breadcrumbs>
  }
  <section>
    <h2>
      {{ serviceType()?.name || '' }}
    </h2>
    <br>
    @if (!pending && !loading()) {
      <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-md-6">
            <div class='form-group' *ngIf='"projectType" as controlName'>
              <label [for]='controlName'>
                Typ projektu *
              </label>
              <select
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                <option [value]='item' *ngFor='let item of form.projectTypes'>
                  {{ item }}
                </option>
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-6'>
            <div class='form-group' *ngIf='"applicationSubject" as controlName'>
              <label [for]='controlName'>
                Nazwa robocza *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu nazwę roboczą'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
        @if (!form.geometry.value) {
          <div class="row">
            <div class="col-12">
              <app-alert [closable]="false">
                Za pomocą narzędzia Wielobok wyznacz obszar obejmujący wszystkie elementy pasa drogowego objęte
                projektem.
                <br>
                Zaleca się uwzględnienie buforu wokół projektowanego zakresu, tak aby obszar nie był ograniczony
                wyłącznie
                do minimalnych granic projektu
              </app-alert>
            </div>
            <div class="col-12">
              <br>
              <app-exposed-map-control [alertMessage]="null" [control]="form.geometry">
              </app-exposed-map-control>
            </div>
          </div>
        }
        <div class="row">
          <div class="col-12">
            <app-alert [closable]="false">
              Przed zamknięciem projektu użytkownik powinien wygenerować i pobrać plik PDF z projektem, wykorzystując
              funkcję Wydruk
            </app-alert>
          </div>
          <div class="col-12">
            @if (contentUrl; as url) {
              <app-execution-of-traffic-organization-projects-map (close)="contentUrl = null" [contentUrl]="url">
              </app-execution-of-traffic-organization-projects-map>
            }
          </div>
        </div>
        <div class='application-actions'>
          <button
            [routerLink]="appId ? '../../' : '../'"
            type='button'
            class='btn btn-secondary'>
            <span>
              Anuluj
            </span>
          </button>
          <button
            type='submit'
            class='btn btn-primary'>
            <span>{{ application()?.description ? 'Zakończ projektowanie' : 'Wygeneruj projekt' }}</span>
          </button>
          @if (application()?.geometry) {
            <button (click)="contentUrl = application()?.description || ''" type="button" class="btn btn-primary">
              Przejdź do projektowania
            </button>
          }
        </div>
      </form>
    } @else {
      <app-spinner>
        {{ pending ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
      </app-spinner>
    }
  </section>
</app-content>
